<template>
  <div class="app-container">

    <nav class="head">
      <h2>{{editorTitle}}</h2>
      <button @click="cancel()">Cancel</button>
      <button @click="save()">Save</button>
      <button @click="deletePostcard()">Delete</button>
    </nav>

    <div class="content">

      <p v-if="mode == 'new'" class="add-postcard-desc">
        Upload a photo or scan of the front and back of your postcard.<br/>
        Give it a title if you like.<br/>
        Include the date the postcard was sent.<br/>
        Add a transcript of the postcard if you like.<br/>
      </p>
      
      <div v-if="!storagePathFront" class="photo-input">
        <label for="photo">Add Postcard Front</label>
        <input
          id="photoFront"
          name="photoFront"
          type="file"
          accept="image/*"
          @change="frontSelected($event)"
          ref="frontImageInput"
          width="350"
        >
        <span class="button-bar" v-if="isFrontSelected">
          <button class="small" @click="clearFrontPhoto()">Clear</button>
          <button v-if="mode !== 'new'" class="small" @click="uploadPostcardFront()">Upload</button>
        </span>
      </div>

      <div v-if="!!storagePathFront" class="photo-delete">
        <button class="small" @click="deletePhoto('front')">Remove Photo</button>
      </div>

      <div class="photo-container">
        <img v-if="!!photoPreviews[0] && !storagePathFront" class="postcard-photo" :src="photoPreviews[0].path" />
        <img v-if="!!storagePathFront" :class="frontPathReloading ? 'photo-reloading' : 'postcard-photo'" :src="storagePathFront" @load="onPhotoLoad('front')" @error="onPhotoError('front', $event)"/>
        <div v-if="!photoPreviews[0] && !storagePathFront" class="photo-placeholder">Postcard Front</div>
        <div v-if="frontPathReloading" class="photo-placeholder">Postcard Front Loading from Server...</div>
      </div>

      <div v-if="!storagePathBack" class="photo-input">
        <label for="photo">Add Postcard Back</label>
        <input
          id="photoBack"
          name="photoBack"
          type="file"
          accept="image/*"
          @change="backSelected($event)"
          ref="backImageInput"
          width="350"
        >
        <span class="button-bar" v-if="isBackSelected">
          <button class="small" @click="clearBackPhoto()">Clear</button>
          <button v-if="mode !== 'new'" class="small" @click="uploadPostcardBack()">Upload</button>
        </span>
      </div>

      <div v-if="!!storagePathBack" class="photo-delete">
        <button class="small" @click="deletePhoto('back')">Remove Photo</button>
      </div>

      <div class="photo-container">
        <img v-if="!!photoPreviews[1] && !storagePathBack" class="postcard-photo" :src="photoPreviews[1].path" />
        <img v-if="!!storagePathBack" :class="backPathReloading ? 'photo-reloading' : 'postcard-photo'" :src="storagePathBack" @load="onPhotoLoad('back')" @error="onPhotoError('back', $event)"/>
        <div v-if="!photoPreviews[1] && !storagePathBack" class="photo-placeholder">Postcard Back</div>
        <div v-if="backPathReloading" class="photo-placeholder">Postcard Back Loading from Server...</div>
      </div>

      <div class="name">
        <label for="postcardName">Name</label>
        <input type="text" id="postcardName" v-model="postcard.name" maxlength="80" placeholder="Name for your postcard" tabindex="1">
      </div>

      <div class="date">
        <label for="date">Postcard Date</label>
        <input type="text" :class="dateValidated ? 'valid' : 'invalid'" id="postcardDate" v-model="postcardDate" @input="formatDate($event)" placeholder="Month/Day/Year"/>
        <span class="formated-date">{{formatedDate}}</span>
        <!-- <date-pick input-id="date" 
                  v-model="postcardDate" 
                  :displayFormat="'M/D/YYYY'" 
                  :selectableYearRange="{from: 1955, to: 2020}"
                  :startWeekOnSunday="true" />
                  -->
      </div>

      <label class="transcript-label" for="postcardTranscript">Transcript</label>
      <div class="postcard-input">
        <textarea id="postcardTranscript" v-model="postcard.transcript" placeholder="Postcard transcript" tabindex="3" rows="20"></textarea>
      </div>

    </div>

    <div class="loading-mask" v-if="isLoading"><span>{{loadingMessage}}</span></div>

  </div>
</template>

<script>
  //import DatePick from 'vue-date-pick'
  import { mapGetters } from 'vuex'

  let vm;
  export default {

    name: 'AddPostcard',

    components: {
      // DatePick
    },

    watch: {
      '$store.state.users.userAuthenticating': (val, oldVal) => {
        console.log(`AddPostcard.watch($store.state.users.userAuthenticating) val [${val}] oldVal [${oldVal}]`);
        if (!val && !!vm.$store.state.users.user.uid && vm.loadingMessage == 'Loading...') {
          vm.appInit();
        }
      }
    },

    data() {
      return {
        isLoading: true,
        loadingMessage: 'Loading...',
        isFrontSelected: false,
        isBackSelected: false,
        photoFileList: [],
        photoPreviews: [],
        frontImageInput: null,
        backImageInput: null,
        storagePathBack: null,
        storagePathFront: null,
        frontPathReloading: false,
        backPathReloading: false,
        storagePathLoads: 0,
        photosChanged: false,
        dateRegx:/\d{1,2}[./-]\d{1,2}[./-]\d{4}/,
        dateString:'',
        dateValidated: false,
        formatedDate: 'date output',
        reloads: {
          count: 0
        },
        postcard: {
          name:`Postcard #${this.$store.state.postcards.postcardCount}` ,
          Created_date: new Date(),
          date: null,
          owner: this.$store.state.users.user.uid,
          photos: [],
          transcript: ''
        },
        mode: 'new'
      }
    },

    computed: {

      editorTitle() {
        return `${this.mode == 'new' ? 'Add' : 'Edit'} Postcard`
      },

      postcardCount() {
        return this.$store.state.postcards.postcards.length
      },

      postcardDate: { // Firestore's Timestamp class requires transformation
        get() {
          let dateStr = '';
          // ignore if postcard is newly created
          if (!this.postcard.date) {
            dateStr = this.dateString;
            console.log(`postcardDate() postcard.date undefined--date input ${dateStr}`);
            return dateStr;
          }
          // parse date into chosen format
          try {
            console.log('postcardDate() parse postcard.date');
            let date = this.postcard.date.toDate ? this.postcard.date.toDate() : this.postcard.date;
            dateStr = this.$moment(date).format('M/D/YYYY');
          }
          catch {
            console.log('postcardDate() no date');
            console.dir(this.postcard.date);
            dateStr = this.dateString;
          }
          return dateStr;
        },
        set(date) {
          if (date == undefined) return;
          this.dateString = date
          console.log(`postcardDate.set() ${date} typeof ${typeof(date)}`);
          if (this.dateValidated) {
            let m = this.$moment(date);
            if (!m.isValid()) {
              console.log(`postcardDate.set() ${date} is not a valid date`);
              return;
            }
            this.postcard.date = this.$firebase.firebase_.firestore.Timestamp.fromDate(m.toDate())
          }
        }
      },

      ...mapGetters('photos', ['photoUrl']),

      ...mapGetters('postcards', ['activePostcard'])

    },

    mounted() {
      console.log(`AddPostcard.mounted() route ${this.$route.name}`);
      // make sure user isn't being authenticated
      if (this.$route.name === 'add-postcard') {
        this.mode = 'new'
      } else {
        this.mode = 'edit'
        this.postcard = this.$store.state.postcards.activePostcard;
      }
      if (!this.$store.state.users.userAuthenticating) {
        this.init();
      }
      vm = this;
      
      // else Authentication watcher above will trigger init
    },

    methods: {

      appInit() {
        console.log(`AddPostcard.appInit() route ${this.$route.name}`);
        // user has reloaded or navigated directly to this page
        this.loadingMessage = 'Loading Postcards...';
        this.$store.dispatch('postcards/getPostcards')
          .then(() => {
            if (this.mode == "new") {
              this.postcard.name = `Postcard #${this.$store.state.postcards.postcards.length + 1}`;
            }
            this.init();
          })
          .catch(this.handleError)
      },

      init() {
        console.log(`AddPostcard.init()`);
        console.dir(this.$store.state.users.user);
        if (this.mode == 'new') 
        {
          console.log(`AddPostcard.init() is new`);
          this.postcard.owner = this.$store.state.users.user.uid;
          this.isLoading = false;
        } 
        else if (this.activePostcard) 
        {
          this.postcard = {...this.activePostcard};
          this.afterPostcardLoaded();
          this.isLoading = false;
        }
        else 
        {
          // get postcard data
          this.$store.dispatch('postcards/getPostcard', this.$route.params.postcard_id)
            .then((data) => {
              console.log(`AddPostcard.init() postcard data`);
              console.dir(data);
              this.postcard = {...data};
              this.afterPostcardLoaded();
              this.isLoading = false;
            })
            .catch(this.handleError);
        }
      },

      afterPostcardLoaded() {
        this.dateString = this.postcardDate;
        if (this.dateRegx.test(this.dateString)) {
          this.dateValidated = true;
        }
        if (this.postcard.photos.length > 0) 
        {
          this.photoFileList = this.postcard.photos;
          this.postcard.photos.forEach((photo) => {
            if (photo.pos == 'front') this.storagePathFront = this.photoUrl(photo, 'medium');
            else if (photo.pos == 'back') this.storagePathBack = this.photoUrl(photo, 'medium');
          });
        } 
        else 
        {
          console.log(`AddPostcard.init() postcard has no photos`);
        }
      },

      formatDate() {
        let dateStr = this.dateString;
        if (!this.dateRegx.test(dateStr)) {
          this.formatedDate = '...';
          this.dateValidated = false;
          // If user is changing date we need to invalidate the postcard.date ref
          if (this.postcard.date) {
            this.postcard.date = null;
          }
        } else {
          let date = this.$moment(dateStr);
          this.postcard.date = date.toDate();
          this.formatedDate = date.toDate().toDateString();
          this.dateValidated = true;
        }
        console.log(`AddPostcard.formatDate() ${dateStr} is valid ${this.dateValidated}`);
      },

      onPhotoClick(photo) {
        console.log(`AddPostcard.onPhotoClick()`);
        console.dir(photo);
      },

      save() {
        console.log(`AddPostcard.save()`);
        console.dir(this.postcard);
        this.isLoading = true;
        this.loadingMessage = 'Saving Postcard...';
        const dispatchMethod = this.mode == 'new' ? 'postcards/createPostcard' : 'postcards/updatePostcard';
        this.$store.dispatch(dispatchMethod, this.postcard) 
          .then((postcard) => {
            this.postcard = {...postcard};
            console.log(`AddPostcard.save() postcard saved`);
            console.dir(this.postcard);
            if (this.mode == 'new' && this.hasPhotos()) {
              this.savePhotos()
                .then(this.afterSavePostcard)
            } else if (this.mode == 'edit') {
              if (this.photosChanged) {
                console.log(`AddPostcard.save() handle photo changes...compare photos:`)
                console.dir(this.postcard.photos);
                console.log(`AddPostcard.save() to photoFileList:`);
                console.dir(this.photoFileList);
              }
              this.close();
            } else {
              console.log(`AddPostcard.save() no photos`)
              this.afterSavePostcard();
            }
          })
          .catch(this.handleError);
      },

      hasPhotos() {
        console.log(`AddPostcard.hasPhotos() photoFileList contains [${this.photoFileList.length}] photos`)
        let result = false;
        this.photoFileList.forEach(p => {
          if (p != null) result = true;
        });
        return result;
      }, 

      savePhotos() {
        console.log(`AddPostcard.savePhotos()`);
        this.loadingMessage = 'Saving Postcard Photos...';
        return this.$store.dispatch('photos/addPhotos', {files:this.photoFileList, postcard_id: this.postcard._id})
          .then((phts) => {
            console.log(`AddPostcard.savePhotos() update postcard.photos`);
            console.dir(phts);
            this.loadingMessage = 'Saving Postcard...';
            this.postcard.photos = this.$store.getters['photos/photosSummary'];
            console.dir(this.postcard);
            return this.$store.dispatch('postcards/updatePostcardPhotos', this.postcard);
          })
          .catch(this.handleError);
      },

      afterSavePostcard(res) {
        console.log(`AddPostcard.afterSavePostcard() res:`);
        console.dir(res);
        if (this.hasPhotos()) {
          this.loadingMessage = 'Loading Photos...';
          this.storagePathFront = this.photoUrl(this.postcard.photos[0], 'medium');
          this.storagePathBack = this.photoUrl(this.postcard.photos[1], 'medium');
        } else {
          this.close();
        }
      },

      deletePostcard() {
        console.log(`AddPostcard.deletePostcard()`);
        // insert confirm dialog here
        this.isLoading = true;
        this.loadingMessage = 'Deleting Postcard...';
        this.$store.dispatch('postcards/delete', this.postcard)
          .then((result) => {
            console.log(`AddPostcard.deletePostcard() postcard delete resutl: ${result}`);
            this.close();
          })
      },

      frontSelected(evnt) {
        console.log(`AddPostcard.frontSelected()`);
        this.frontImageInput = evnt.target;
        console.dir(this.frontImageInput);
        let photo = this.photoFileList[0] = this.frontImageInput.files[0];
        this.isFrontSelected = this.frontImageInput.files.length > 0;
        this.photosChanged = true;
        if (this.isFrontSelected && window.URL && photo) {
            let img = {
              path: window.URL.createObjectURL(photo),
              name: photo.name,
              index: 0
            };
            console.log(`AddPostcard.frontSelected() add img to previews`);
            console.dir(img);
            this.photoPreviews[0] = img;
        }
      },

      backSelected(evnt) {
        console.log(`AddPostcard.backSelected()`);
        this.backImageInput = evnt.target;
        console.dir(this.backImageInput);
        let photo = this.photoFileList[1] = this.backImageInput.files[0];
        this.isBackSelected = this.backImageInput.files.length > 0;
        this.photosChanged = true;
        if (this.isBackSelected && window.URL && photo) {
          let img = {
            path: window.URL.createObjectURL(photo),
            name: photo.name,
            index: 1
          };
          console.log(`AddPostcard.backSelected() add img to previews`);
          console.dir(img);
          this.photoPreviews[1] = img;
        }
      },

      uploadPostcardBack() {
        console.log(`AddPostcard.uploadPostcardBack()`);
        console.dir(this.photoFileList[1]);
        this.$store.dispatch('photos/addPhoto', {file:this.photoFileList[1], postcard_id: this.postcard._id, pos: 'back'})
          .then(photo => {
            // Add photo to postcard
            this.postcard.photos[1] = this.$store.getters['photos/photoSummary'](photo);
            this.$store.dispatch('postcards/updatePostcardPhotos', this.postcard)
              .then(() => {
                this.storagePathBack = this.photoUrl(this.postcard.photos[1], 'medium');
                this.isBackSelected = true;
              })
              .catch(this.handleError);
          })
          .catch(this.handleError);
      },

      uploadPostcardFront() {
        console.log(`AddPostcard.uploadPostcardFront()`);
        console.dir(this.photoFileList[0]);
        this.$store.dispatch('photos/addPhoto', {file:this.photoFileList[0], postcard_id: this.postcard._id, pos: 'front'})
          .then(photo => {
            // Add photo to postcard
            this.postcard.photos[0] = this.$store.getters['photos/photoSummary'](photo);
            this.$store.dispatch('postcards/updatePostcardPhotos', this.postcard)
              .then(() => {
                this.storagePathFront = this.photoUrl(this.postcard.photos[0], 'medium');
                this.isFrontSelected = true;
              })
              .catch(this.handleError);
          })
          .catch(this.handleError);
      },

      onPreviewClick(photo) {
        console.log(`AddPostcard.onPreviewClick()`);
        console.dir(photo);
      },

      clearFrontPhoto() {
        this.photoPreviews[0] = null;
        this.photoFileList[0] = null;
        this.isFrontSelected = false;
        this.$refs.frontImageInput.value = null;
      },

      clearBackPhoto() {
        this.photoPreviews[1] = null;
        this.photoFileList[1] = null;
        this.isBackSelected = false;
        this.$refs.backImageInput.value = null;
      },

      onPhotoError(pos, evnt) {
        if (this.reloads.count > 20) {
          this.close();
        }
        if (pos == 'front') 
        {
          if (!this.frontPathReloading) {
            this.frontPathReloading = true;
          }
          this.reloads.timeout = setTimeout(() => {
            this.reloads.count++;
            let reloadUrl = `${this.storagePathFront}?reload=${this.reloads.count}`;
            console.log(`AddPostcard.onPhotoError() reload ${reloadUrl}`);
            evnt.target.src = reloadUrl;
          }, 2000)
        }
        else 
        {
          if (!this.backPathReloading) {
            this.backPathReloading = true;
          }
          this.reloads.timeout = setTimeout(() => {
            this.reloads.count++;
            let reloadUrl = `${this.storagePathBack}?reload=${this.reloads.count}`;
            console.log(`AddPostcard.onPhotoError() reload ${reloadUrl}`);
            evnt.target.src = reloadUrl;
          }, 2000)
        }
      },

      onPhotoLoad(pos) {
        console.warn(`AddPostcard.onPhotoLoad() ${pos}`);
        if (pos == 'front') 
        {
          this.frontPathReloading = false;
        }
        else 
        {
          this.backPathReloading = false;
        }
        this.storagePathLoads++
        if (this.mode == 'new' && this.storagePathLoads > 1) {
          setTimeout(() => {
            this.close()
          }, 500)
        }
      },

      deletePhoto(pos) {
        console.warn(`AddPostcard.deletePhoto() ${pos}`);
        const photo = this.photoFileList.find(p => p.pos == pos);
        console.dir(photo);
        if (photo && photo.id) {
          this.loadingMessage = 'Removing Photo...';
          this.isLoading = true;
          console.warn(`AddPostcard.deletePhoto() remove photo ${photo.id}`);
          this.$store.dispatch('photos/deletePhoto', {postcard_id: this.postcard._id, photo_id: photo.id})
            .then((success) => {
              console.warn(`AddPostcard.deletePhoto() success ${success}`);
              this.isLoading = false;
              this.photoFileList[this.photoFileList.indexOf(photo)] = null;
              this[pos == 'front' ? 'storagePathFront' : 'storagePathBack'] = null;
              this.photosChanged = true;
            })
        }
      },

      cancel() {
        console.warn(`AddPostcard.cancel()`);
        this.$router.back();
      },

      close() {
        console.warn(`AddPostcard.close()`);
        this.isLoading = false;
        if (this.$store.state.postcards.postcardCount > 0) 
        {
          this.$router.replace('/postcards/recent');
        }
        else {
          this.$router.replace('/home');
        }
      },

      handleError(err) {
        console.warn(`AddPostcard.handleError()`);
        console.dir(err);
        if (this.isLoading) {
          this.isLoading = false;
          //vm.messageTitle = 'Problem Saving Note';
          //vm.messageBody = 'An error occurred while attempting to save this note. Make sure the note has both a name and note body text.';
          //vm.showMessage = true;
        }
      }

    },

  }
</script>

<style lang="scss" scoped>

  .content {
     padding: 15px 20px;
     text-align: left;
     & > div {
       margin-bottom: 15px;
     }
     
    .add-postcard-desc {
      max-width: 600px;
      margin: 30px auto;
      line-height: 1.5rem;
    }
  }

  .name, .date {
    label {
      display: inline-block;
      min-width: 140px;
      text-align: right;
      margin-right: 10px;
    }
  }

  .formated-date {
    display: inline-block;
    margin-left: 10px;
    color: #666666;
  }

  input, #postcardName {
    min-width: 600px;
  }
  .input-info {
    margin-left: 10px;
    font-size: smaller;
  }
  .char-count {
    color: orangered;
  }

  .date * {
    display: inline-block;
  }
  input.invalid, input.invalid:active {   
    border: 2px solid orangered;
    box-shadow: 0 0 2px orangered;     
  }
  input.valid, input.valid:active {
    border: 2px solid green;
    box-shadow: 0 0 2px green;
  }

  .photo-input {
    min-height: 35px;
    max-width: 72 0px;
    vertical-align: middle;
    label, input {
      display: inline-block;
      margin:10px 10px 0  0;
    }
    .button-bar {
      float: right;
      button + button {
        margin-left: 5px;
      }
    }
  }

  .photo-container {
    margin: auto;
    background-color: lightgrey;
    max-width: 600px;
    min-width: 400px;
    max-height: 600px;
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center; 
    .postcard-photo {
      margin: auto;
      max-width: 600px;
      min-width: 400px;
      max-height: 600px;
      min-height: 300px;
    }
    .photo-placeholder {
      margin: auto;
      vertical-align: middle;
    }
    .photo-reloading {
      position: absolute;
      left: 5000px;
    }
  }

  .photo-delete {
    text-align: right;
    button {
      margin-right: 20px;
    }
  }

  .transcript-label {
    float: left;
    margin-left: 60px;
  }

  .postcard-input {
    max-width: 600px;
    margin: auto;
  }

  .content textarea {
    width: 100%;
    height: 100%;
    overflow: auto;
  }  

  #postcardTranscript {
    height: 100%;

  }
</style>